/* tslint:disable */
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Observable, Subject } from 'rxjs';
import { ViewParametroSistemaEriproc } from '../../models/ViewParametroSistemaEriproc';


/**
 * Api services for the `ViewParametroSistemaEriproc` model.
 */

export class ViewParametroSistemaEriprocApi extends BaseLoopBackApi {

  constructor(
     
  ) {
    
    super();
    
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} options 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `ViewParametroSistemaEriproc` object.)
   * </em>
   */
   buscarParametrosLPU(customHeaders) {
    
    let _method = "GET";
    let _url = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/ViewParametroSistemaEriprocs/buscarParametrosLPU";
    let _routeParams = {};
    let _postBody = {};
    let _urlParams = {};
    
    
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }



  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewParametroSistemaEriproc`.
   */
  getModelName() {
    return "ViewParametroSistemaEriproc";
  }
}




// WEBPACK FOOTER //
// ./src/sdk/services/custom/ViewParametroSistemaEriproc.js